import UserInactivity from './UserInactivity';
export default UserInactivity;
